import { defineMessages } from 'react-intl';

/** The copy of step 4 "Send from" (design outreach-v2 e1, e2, e3). */
export const sendFromMessages = defineMessages({
  connectTitle: { id: 'app.outreach.sendFrom.connectTitle', defaultMessage: 'Connect your mailbox' },
  connectHint: {
    id: 'app.outreach.sendFrom.connectHint',
    defaultMessage:
      'Any mailbox that has IMAP and SMTP: Gmail, iCloud, Yahoo, Zoho, Fastmail or your own domain. Takes about 2 minutes.',
  },
  connect: { id: 'app.outreach.sendFrom.connect', defaultMessage: 'Connect your mailbox' },
  limitReached: { id: 'app.outreach.sendFrom.limitReached', defaultMessage: 'Mailbox limit reached' },
  pickTitle: { id: 'app.outreach.sendFrom.pickTitle', defaultMessage: 'Send from' },
  pickHint: {
    id: 'app.outreach.sendFrom.pickHint',
    defaultMessage: 'Pick one or more. Plug spreads the pitches over them.',
  },
  pickMeta: {
    id: 'app.outreach.sendFrom.pickMeta',
    defaultMessage: '{count} of {limit} on your plan',
  },
  ownerOnly: {
    id: 'app.outreach.sendFrom.ownerOnly',
    defaultMessage: 'Owner only: change or remove a mailbox in Settings → Outreach.',
  },
  rowWarming: {
    id: 'app.outreach.sendFrom.rowWarming',
    defaultMessage: 'day {day} of the warm-up · {cap} a day now',
  },
  rowReady: { id: 'app.outreach.sendFrom.rowReady', defaultMessage: 'ready · {cap} a day' },
  rowPaused: { id: 'app.outreach.sendFrom.rowPaused', defaultMessage: 'Paused' },
  rowReconnect: { id: 'app.outreach.sendFrom.rowReconnect', defaultMessage: 'The password stopped working' },
  addedByYou: { id: 'app.outreach.sendFrom.addedByYou', defaultMessage: 'added by you' },
  addedBy: { id: 'app.outreach.sendFrom.addedBy', defaultMessage: 'added by {name}' },
  pick: { id: 'app.outreach.sendFrom.pick', defaultMessage: 'Send {song} from {address}' },
  whyRampTitle: { id: 'app.outreach.sendFrom.whyRampTitle', defaultMessage: 'A new mailbox starts slowly' },
  whyRamp: {
    id: 'app.outreach.sendFrom.whyRamp',
    defaultMessage: '3 pitches a day, then more over 3 weeks, so the mailbox stays out of spam.',
  },
  whyRepliesTitle: { id: 'app.outreach.sendFrom.whyRepliesTitle', defaultMessage: 'Replies come to you' },
  whyReplies: {
    id: 'app.outreach.sendFrom.whyReplies',
    defaultMessage: 'And to the Music24 Inbox, with a suggested answer.',
  },
  whyTeamTitle: { id: 'app.outreach.sendFrom.whyTeamTitle', defaultMessage: 'Your team can add one' },
  whyTeam: {
    id: 'app.outreach.sendFrom.whyTeam',
    defaultMessage: 'Any member can connect a mailbox. Only the owner changes or removes it.',
  },
  barNone: { id: 'app.outreach.sendFrom.barNone', defaultMessage: 'Connect a mailbox to go on' },
  barPickOne: { id: 'app.outreach.sendFrom.barPickOne', defaultMessage: 'Pick a mailbox to go on' },
  barFrom: { id: 'app.outreach.sendFrom.barFrom', defaultMessage: 'From {addresses}' },
  saveFailed: { id: 'app.outreach.sendFrom.saveFailed', defaultMessage: 'We could not save the mailbox. Try again.' },
});
